<div class="tour-title-wrapper">
    <span class="tour-title">Ausstattung</span>
</div>
<div class="tour-wrapper" *ngIf="facilityList?.length > 0">
    <ng-container *ngFor="let op of facilityList | slice:0:slicenbr">
        <button class="tour-item-wrapper" (click)="selected(op)" matRipple>
            <mat-icon class="tour-item-icon ">{{selectedList.indexOf(op.code) >= 0 ? 'check_box' :
                'check_box_outline_blank'}}</mat-icon>
            <span class="tour-item-name">{{op.name}}</span>
        </button>
    </ng-container>
    <ng-container *ngIf="facilityList.length > 5">
        <ng-container *ngIf="(slicenbr < facilityList.length) else less">
            <button class="showallbtn" (click)="showMore(facilityList.length)" matRipple>
                <span>alle {{facilityList.length}} anzeigen</span>
            </button>
        </ng-container>
        <ng-template #less>
            <button class="showallbtn" (click)="showMore(5)" matRipple>
                <span>weniger anzeigen</span>
            </button>
        </ng-template>
    </ng-container>
</div>